import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import {
    Container,
    Row,
    Col,
    Table,
    Card,
    CardBody, 
} from "reactstrap"
import CardItem from "./CardItem"
import { salesDeveloperPrefix } from "configs/routePrefix"
import Paginator from "components/Common/Paginator/Paginator"
import FilterModal from "./FilterModal"
import FilterIcon from "assets/images/filter.png"
import { useDispatch, useSelector } from "react-redux"
import { appendFilters } from "store/adminFilter/actions"
import BuildingService from "services/SalesDeveloper/BuildingService"

const BuildingList = (props) => {
    const filter = useSelector(state=> state.adminFilter)
    const buildingService = new BuildingService()
    const [active, setActive] = useState('all')
    const [modal, setModal] = useState(false)
    const [searchWord, setSearchWord] = useState("")
    const [list, setList] = useState([])
    const [filtersParams, setFilterParams] = useState(null)
    const [shouldGetData, setShouldGetData] = useState(false)
    const toggle = () => setModal(!modal)
    const AuthData = useSelector(state => state.Auth)
    const isExist = (data) => AuthData.permissions[data]
    const [noData, setNoData] = useState(false)
    const compound_id = filter?.compound_id || localStorage.getItem("compound_id")
    const [pageOptions, setPageOptions] = useState({
        sizePerPage: 10,
        totalSize: 1,
    })
    const [filterData, setFilterData] = useState({
        // unit_type_ids: null,
        // compound_ids: null,
        ...filter
    })
    const dispatch = useDispatch()

    const OnSearchChange = (e) => {
        const search = e.target.value
        setSearchWord(search)
    }

    const addHandler = () => {
        props.history.push(`${salesDeveloperPrefix}/add-building`)
    }

    const updateHandler = (id) => {
        dispatch(appendFilters({addBuilding: null}))
        props.history.push(`${salesDeveloperPrefix}/edit-building/${id}`)
    }

    useEffect(() => {
        dispatch(appendFilters({building_id: null}))
        // debounce solution to reduce request data from api
        const timeoutId = setTimeout(() => {
            const params = {}
            params['compound_ids'] = compound_id
            if (active != 'all') params['status'] = active === "active" ? 1 : 0
            if (searchWord.trim().length) params['keyword'] = searchWord
            if (!!filterData ?.unit_type_ids) params['unit_type_ids'] = filterData ?.unit_type_ids//?.map(item => item.value).join()
            if(filterData ?.unit_type?.length > 0){
                dispatch(appendFilters({unit_type: filterData ?.unit_type, unit_type_ids: filterData?.unit_type_ids }))
            }
            setFilterParams({ ...params })
        }, 1000)

        return () => clearTimeout(timeoutId)
    }, [active, searchWord, filterData.unit_type_ids])

    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>buildings</title>
                </MetaTags>
                <Container fluid>
                    <Row className="mb-1">
                        <Col md={6}>
                            <div className="d-flex mb-2">
                                <button className="p-0 m-0 border-0 me-2"
                                style={{background: 'none'}}
                                    onClick={() => {
                                        //props.history.location.pathname
                                        props.history?.push(`${salesDeveloperPrefix}/cards/${compound_id}`)
                                    }}>
                                    <i className="fa fa-arrow-left text-success me-2 font-size-16"></i>
                                </button>
                                <h4 className="m-0">Manage Buildings</h4>
                            </div>
                            <p>You can manage All Buildings in the Selected Compound</p>
                        </Col>
                    </Row>
                    <Row className="mb-1">
                        <Col md={6}>
                            <div className="form-group has-search">
                                <span className="fa fa-search form-control-feedback"></span>
                                <input type="text" className="form-control" placeholder="Search by building name, I.D" onChange={(e) => OnSearchChange(e)}
                                    value={searchWord} />
                            </div>
                        </Col>
                        <Col md={6} className='d-flex justify-content-md-end '>
                            {isExist('add_compound') &&<div className="mb-2 me-3">
                                <button
                                    className="btn btn-success btnHeight px-lg-4"
                                    onClick={()=>{
                                        addHandler()
                                        dispatch(appendFilters({addBuilding: 'addBuilding'}))
                                    }}
                                >
                                    Add New Building
                                    </button>
                            </div>}
                            {isExist('add_compound') &&<div className="mb-2">
                                <button
                                    className="btn btn-secondary btnHeight px-lg-4"
                                    onClick={()=>{
                                        addHandler()
                                        dispatch(appendFilters({addBuilding: 'addBuildings'}))
                                    }}
                                >
                                    Add New Buildings
                                    </button>
                            </div>}
                        </Col>
                    </Row>
                    <Row className="my-4">
                        <Col md={6} sm={8} className="mb-3">
                            <button
                                className="btn btnHeight me-2 px-4"
                                style={{
                                    background: active == "all" ? "#556ee6" : "#f4f4f4",
                                    color: active == "all" ? "#FFF" : "#495057"
                                }}
                                onClick={() => {
                                    setActive("all")
                                }}
                            >
                                All
                            </button>
                            <button
                                className="btn btnHeight me-2 px-4"
                                style={{
                                    background: active == "active" ? "#556ee6" : "#f4f4f4",
                                    color: active == "active" ? "#FFF" : "#495057"
                                }}
                                onClick={() => {
                                    setActive("active")
                                }}
                            >
                                Active
                            </button>
                            <button
                                className="btn btnHeight me-2 px-4"
                                style={{
                                    background: active == "deactive" ? "#556ee6" : "#f4f4f4",
                                    color: active == "deactive" ? "#FFF" : "#495057"
                                }}
                                onClick={() => {
                                    setActive("deactive")
                                }}
                            >
                                Deactive
                            </button>
                        </Col>
                        <Col md={6} sm={4} className="mb-3 d-flex flex-row-reverse">
                            <button className="btn btnUpload btnHeight px-4" style={{ margin: "0" }} onClick={() => {
                                setModal(!modal)
                            }}> <img src={FilterIcon} style={{ marginRight: "5px" }} />Filter</button>
                        </Col>
                    </Row>
                    <div>
                        <Card className="w-100 mt-4">
                            <CardBody>
                                <div className="py-3">
                                    <div>
                                        <div className="table-responsive position-relative">
                                            <Table>
                                                <thead>
                                                    <tr className="bgHeaderTable">
                                                        <th className="font-size-14">
                                                        I.D
                                                        </th>
                                                        <th className="font-size-14">
                                                            Building name
                                                        </th>
                                                        <th className="font-size-14">
                                                            No. of Floors
                                                        </th>
                                                        <th className="font-size-14">
                                                            No. of Available Units
                                                        </th>
                                                        <th className="font-size-14">
                                                            No. of Bought Units
                                                        </th>
                                                        <th className="font-size-14">
                                                            status
                                                        </th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {list ?.map((item, index) => (
                                                        <CardItem
                                                            key={index}
                                                            index={index}
                                                            {...item}
                                                            item={item}
                                                            Service={BuildingService}
                                                            setShouldGetData={setShouldGetData}
                                                            updateHandler={()=> updateHandler(item.id)}
                                                        />
                                                    ))}
                                                </tbody>
                                            </Table>
                                            {noData && <b style={{
                                                    left: '50%',
                                                    position: 'absolute',
                                                    transform: 'translate(-50%, 15px)'
                                                }}>
                                                   There's no building in the selected compound
                                                </b>}
                                        </div>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                        <Row className="d-flex justify-content-end">
                            <Col className="d-flex justify-content-between" md={12} sm={12}>
                                <Paginator
                                    service={buildingService}
                                    pageOptions={pageOptions}
                                    setData={(data) => {
                                        setList([...data])
                                        if(data?.length > 0){
                                            setNoData(false)
                                        } else{
                                            setNoData(true)
                                        }
                                    }}
                                    setPageOptions={setPageOptions}
                                    filtersParams={filtersParams}
                                    shouldGetData={shouldGetData}
                                    setShouldGetData={setShouldGetData}
                                />
                            </Col>
                        </Row>
                    </div>
                    {modal ? <FilterModal
                        toggle={toggle}
                        modal={modal}
                        onSumbit={(data) => setFilterData(data)}
                        filterData={filterData}
                    /> : null}
                </Container>
            </div>
        </React.Fragment >
    )
}

export default BuildingList
